import React, { SyntheticEvent } from "react";

import { useTheme, IconButton } from "@mui/material";

import { AnyColor } from "react-colorful/dist/types";
import { colord } from "colord";

import { SquareRounded, DoNotDisturb } from '@mui/icons-material';

interface ColorSwatchProps {
  color: AnyColor | undefined;
  /**
   * Used for components that must has a color applied. If the selected color is reset,
   * it will rever to this color.
   */
  defaultColor?: string | null;
  disableHover?: boolean;
  onClick?: (event: SyntheticEvent) => void;
  /**
   * Size of the swatch based off of MUI's sizes
   */
  size?: "small" | "medium" | "large";
}

export default function ColorSwatch(props: ColorSwatchProps): React.JSX.Element {
  const theme = useTheme();
  const colorAsHexString = props.color ? colord(props.color).toHex() : '';
  const backgroundColor = colorAsHexString || props.defaultColor || theme.colors.primary.lighter;
  let icon = <DoNotDisturb />;

  if (props.color || props.defaultColor) {
    icon = <SquareRounded sx={{ color: "transparent" }} />
  }

  const style: any = {
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: backgroundColor
  };
  if (props.disableHover)  {
    style["&:hover"] = {
      backgroundColor: backgroundColor
    }
  }

  return (
    <IconButton
      size={props.size ?? "medium"}
      sx={style}
      onClick={props.onClick}
    >
      {icon}
    </IconButton>
  )
}
